/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent202,
  PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent400,
  PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent401,
  PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent404,
  PutApiV1ClassroomdisciplineIdMaterialsMaterialidContentMutationRequest,
  PutApiV1ClassroomdisciplineIdMaterialsMaterialidContentMutationResponse,
  PutApiV1ClassroomdisciplineIdMaterialsMaterialidContentPathParams,
} from "../../types/classPlanningMaterialController/PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent.ts";
import { upsertMaterialContentRequestViewModelSchema } from "../upsertMaterialContentRequestViewModelSchema.ts";

export const putApiV1ClassroomdisciplineIdMaterialsMaterialidContentPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    materialId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1ClassroomdisciplineIdMaterialsMaterialidContentPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ClassroomdisciplineIdMaterialsMaterialidContent202Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassroomdisciplineIdMaterialsMaterialidContent400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassroomdisciplineIdMaterialsMaterialidContent401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassroomdisciplineIdMaterialsMaterialidContent404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdMaterialsMaterialidContent404>;

export const putApiV1ClassroomdisciplineIdMaterialsMaterialidContentMutationRequestSchema =
  z.lazy(
    () => upsertMaterialContentRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdMaterialsMaterialidContentMutationRequest>;

export const putApiV1ClassroomdisciplineIdMaterialsMaterialidContentMutationResponseSchema =
  z.lazy(
    () => putApiV1ClassroomdisciplineIdMaterialsMaterialidContent202Schema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdMaterialsMaterialidContentMutationResponse>;
